import { Flex } from 'antd';

import { useSingleGraphReferenceContext } from 'business/providers/graph-reference';
import { handlePrintWithChart } from 'technical/handle-print-with-chart';
import { PrintButton } from 'ui/button/print-button';

import { ExcavationBuildTimeExport } from './excavation-build-time-export';

export const ExcavationBuildTimeHeader = () => {
  const { ref } = useSingleGraphReferenceContext();

  return (
    <Flex gap={4}>
      <PrintButton onClick={() => handlePrintWithChart(ref)} />
      <ExcavationBuildTimeExport />
    </Flex>
  );
};
